document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.getElementById('wishlist-dialog');
  if (!dialog) return;
  const key = 'defiant-attitude-wishlist-v1';
  const list = dialog.querySelector('[data-wishlist-list]');
  const status = dialog.querySelector('[data-wishlist-status]');
  const labels = dialog.dataset;
  let items = [];
  let storageFailed = false;
  const valid = item => item && /^\d+$/.test(String(item.id)) && typeof item.title === 'string' && typeof item.url === 'string' && /^\/products\/[\w%-]+(?:\?[^\s]*)?$/.test(item.url);
  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(value) ? value.filter(valid).slice(0, 100) : [];
    } catch (_) { items = []; storageFailed = true; }
  }
  function write() {
    try { localStorage.setItem(key, JSON.stringify(items)); storageFailed = false; }
    catch (_) { storageFailed = true; }
  }
  function render() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = items.length || ''; });
    document.querySelectorAll('[data-wishlist-save]').forEach(button => {
      const saved = items.some(item => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? labels.remove : labels.save);
      const text = button.querySelector('span');
      if (text) text.textContent = saved ? labels.remove : labels.save;
    });
    list.replaceChildren();
    dialog.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
    status.textContent = storageFailed ? labels.error : '';
    items.forEach(item => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.href = item.url;
      if (typeof item.image === 'string') {
        try {
          const url = new URL(item.image, location.origin);
          if (url.protocol === 'https:' && (url.host === location.host || url.host === 'cdn.shopify.com')) {
            const image = document.createElement('img');
            image.src = url.href; image.alt = ''; image.width = 80; image.height = 100; image.loading = 'lazy'; link.append(image);
          }
        } catch (_) {}
      }
      const title = document.createElement('span');
      title.textContent = item.title; link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = labels.remove;
      remove.addEventListener('click', () => {
        items = items.filter(x => x.id !== item.id); write(); render();
        dialog.querySelector('[data-wishlist-close]').focus();
      });
      row.append(link, remove); list.append(row);
    });
  }
  document.querySelectorAll('[data-wishlist-open]').forEach(button => button.addEventListener('click', () => { render(); dialog.showModal(); }));
  dialog.querySelector('[data-wishlist-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-save]');
    if (!button) return;
    const item = { id: button.dataset.productId, title: button.dataset.productTitle, url: button.dataset.productUrl, image: button.dataset.productImage };
    if (!valid(item)) return;
    if (items.some(x => x.id === item.id)) items = items.filter(x => x.id !== item.id);
    else if (items.length < 100) items.push(item);
    write(); render();
    if (storageFailed) dialog.showModal();
  });
  window.addEventListener('storage', event => { if (event.key === key) { read(); render(); } });
  read(); render();
});
